export interface AppConfig {
  alchemy: {
    key?: string
  }
  chains: {
    chainId: number
    name: string
    symbol: string
    chainName: string
    rpcUrl: string
    icon: string
  }[]
  contractRedeem: Map<number, string | undefined>
  contractToken: Map<number, string>
  blockExplorerUrls: Map<number, string>
  explorerRecommendedWalletIds: string[]
}

const APP_CONFIG: AppConfig = {
  alchemy: {
    key: process.env.REACT_APP_ALCHEMY_PROJECT_ID,
  },
  chains: [
    {
      chainId: 137,
      name: 'polygon',
      symbol: 'MATIC',
      chainName: 'Polygon Mainnet',
      rpcUrl: `https://polygon-mainnet.g.alchemy.com/v2/${process.env.REACT_APP_ALCHEMY_PROJECT_ID}`,
      icon: '',
    },
  ],
  contractRedeem: new Map([[137, process.env.REACT_APP_REDEEM_CONTRACT]]),
  contractToken: new Map([[137, '0x']]),
  blockExplorerUrls: new Map([[137, 'https://polygonscan.com/']]),
  explorerRecommendedWalletIds: [
    // metamask
    'c57ca95b47569778a828d19178114f4db188b89b763c899ba0be274e97267d96',
    // coinbase
    'fd20dc426fb37566d803205b19bbc1d4096b248ac04548e3cfb6b3a38bd033aa',
    // trust
    '4622a2b2d6af1c9844944291e5e7351a6aa24cd7b23099efac1b2fd875da31a0',
    // zerion
    'ecc4036f814562b41a5268adc86270fba1365471402006302e70169465b7ac18',
    // safe
    '225affb176778569276e484e1b92637ad061b01e13a048b35a9d280c3b58970f',
    // ledger
    '19177a98252e07ddfc9af2083ba8e07ef627cb6103467ffebb3f8f4205fd7927',
    // zengo
    '9414d5a85c8f4eabc1b5b15ebe0cd399e1a2a9d35643ab0ad22a6e4a32f596f0',
  ],
}

export default APP_CONFIG
